import { render, staticRenderFns } from "./payment-gateway.vue?vue&type=template&id=13b35fbe&"
import script from "./payment-gateway.vue?vue&type=script&lang=js&"
export * from "./payment-gateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports